export default __webpack_public_path__ + "static/media/levelTest-Illustration07.89877e43.jpg";